import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportBubble = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8802 13.5301C20.2702 17.2701 17.4802 20.1301 13.7702 20.8301C11.7302 21.2201 9.80023 20.9101 8.13023 20.1301C7.85023 19.9901 7.41021 19.9401 7.11021 20.0001C6.49021 20.1501 5.43023 20.4101 4.54023 20.6101C3.68023 20.8201 3.15022 20.2901 3.37022 19.4401L3.98024 16.8801C4.05024 16.5801 3.98023 16.1301 3.85023 15.8501C3.09023 14.2601 2.79023 12.4101 3.10023 10.4701C3.70023 6.75007 6.72024 3.73006 10.4502 3.11006C16.6102 2.12006 21.8602 7.36006 20.8502 13.5201L20.8802 13.5301Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8.08997V12.89",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16.5H12.01",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgReportBubble;
